// The unified-API surface lives in the api service; its codes carry the `API-*`
// prefix. Legacy `UNIFIED_*` flat names are kept as aliases (UnifiedError and the
// unified engine still throw them).
const UNIFIED_UNSUPPORTED_ENTITY = { message: "Unified entity not found", severity: "info", status: 404, service: "api" };
const UNIFIED_UNSUPPORTED_OPERATION = { message: "Operation not supported for this unified entity", severity: "info", status: 404, service: "api" };
const UNIFIED_NO_CONNECTED_PROVIDER = { message: "No connected provider for this unified entity", severity: "info", status: 404, service: "api" };
const UNIFIED_MULTIPLE_PROVIDERS = { message: "Multiple providers connected; specify one", severity: "info", status: 409, service: "api" };
const UNIFIED_CONNECTION_NOT_FOUND = { message: "No such connection for this provider", severity: "info", status: 404, service: "api" };
const UNIFIED_CURSOR_INVALID = { message: "Invalid unified pagination cursor", severity: "info", status: 400, service: "api" };
const UNIFIED_VALIDATION_FAILED = { message: "Unified record validation failed", severity: "info", status: 400, service: "api" };
const UNIFIED_PROVIDER_AUTH_FAILED = { message: "Provider authentication failed", severity: "warn", status: 401, service: "api" };
const UNIFIED_PROVIDER_RATE_LIMITED = { message: "Provider rate limit exceeded", severity: "warn", status: 429, service: "api" };
const UNIFIED_PROVIDER_ERROR = { message: "Provider request failed", severity: "error", status: 502, service: "api" };
/** API service codes (unified API surface). Canonical `API-*`; legacy `UNIFIED_*` kept as aliases. */
export const API_ERRORS = {
    "API-UNIFIED-ENTITY-UNSUPPORTED": UNIFIED_UNSUPPORTED_ENTITY,
    "API-UNIFIED-OPERATION-UNSUPPORTED": UNIFIED_UNSUPPORTED_OPERATION,
    "API-UNIFIED-NO-PROVIDER": UNIFIED_NO_CONNECTED_PROVIDER,
    "API-UNIFIED-MULTIPLE-PROVIDERS": UNIFIED_MULTIPLE_PROVIDERS,
    "API-UNIFIED-CONNECTION-NOT-FOUND": UNIFIED_CONNECTION_NOT_FOUND,
    "API-UNIFIED-CURSOR-INVALID": UNIFIED_CURSOR_INVALID,
    "API-UNIFIED-VALIDATION-FAILED": UNIFIED_VALIDATION_FAILED,
    "API-UNIFIED-PROVIDER-AUTH-FAILED": UNIFIED_PROVIDER_AUTH_FAILED,
    "API-UNIFIED-PROVIDER-RATE-LIMITED": UNIFIED_PROVIDER_RATE_LIMITED,
    "API-UNIFIED-PROVIDER-ERROR": UNIFIED_PROVIDER_ERROR,
    UNIFIED_UNSUPPORTED_ENTITY,
    UNIFIED_UNSUPPORTED_OPERATION,
    UNIFIED_NO_CONNECTED_PROVIDER,
    UNIFIED_MULTIPLE_PROVIDERS,
    UNIFIED_CONNECTION_NOT_FOUND,
    UNIFIED_CURSOR_INVALID,
    UNIFIED_VALIDATION_FAILED,
    UNIFIED_PROVIDER_AUTH_FAILED,
    UNIFIED_PROVIDER_RATE_LIMITED,
    UNIFIED_PROVIDER_ERROR,
};
//# sourceMappingURL=api.js.map